import React, { useState, useEffect } from "react";
import Carousel from "react-elastic-carousel";
import CourseItem from "./CourseItem";
import "./course.css";
import { get, post } from "../../util/axiosConfig/AxiosConfig";
import dummyImg from "../../template/images/no-event.png";
import spinner from '../../template/images/Spinner.gif';
import noResult from '../../template/images/no_result.png';

const Course = (props) => {
  const { mainSecTitle } = props;
  const [loading, setLoading] = useState(false);
  const [coursesData, setCoursesData] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchCategory();
  }, []);

  useEffect(() => {
    fetchData();
  }, [activeTab]);


  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await get(`web/api/v1/lms-web/open/get-course-list/${activeTab}`);
      setCoursesData(response);
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Category
  const fetchCategory = async () => {
    try {
      setLoading(true);
      const response = await get("master/api/v1/lms-master/LmsCourseCategoryMaster/getAllLmsCourseCategoryMaster/web");
      setTabs(response);
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 600, itemsToShow: 2 },
    { width: 750, itemsToShow: 3 },
    { width: 1000, itemsToShow: 3 },
    { width: 1100, itemsToShow: 4 },
    // { width: 2000, itemsToShow: 4.5 },
  ];

  const settings = {
    breakPoints: breakPoints,
    pagination: true,
    isRTL: false,
    showArrows: false,
    enableMouseSwipe: true,
    className: "my-carousel",
    focusOnSelect: false,
    enableAutoPlay: false,
    disableArrowsOnEnd: true,
    autoTabIndexVisibleItems: true,
    enableSwipe: false,
    pagination: true,
    // itemPadding: [10, 10, 10, 10],
    // outerSpacing: [100]
    renderPagination: ({ pages, activePage, onClick }) => (
      <div className="custom-pagination">
        {pages.map((page) => (
          <button
            key={page}
            className={page === activePage ? "active" : ""}
            onClick={() => onClick(page)}
          >
            {/* {page} */}{" "}
          </button>
        ))}
      </div>
    ),
  };
  //   get function
  //   get("api/v1/lms-web/open/get-course-list")
  //     .then((response) => {
  //       setLoading(true);
  //       console.log("get course list", response);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.error(error);
  //     });

  //   Course card data
  //   const coursesData = [
  //     {
  //       courseId: "1",
  //       title: "XXI-A PMS Distributor",
  //       author: "Avinash Kulkarni",
  //       duration: "35",
  //       price: "599",
  //     },
  //     {
  //       courseId: "2",
  //       title: "Demo Course 1",
  //       author: "John Doe",
  //       duration: "20",
  //       price: "499",
  //     },
  //     {
  //       courseId: "3",
  //       title: "XXI-A PMS Distributor",
  //       author: "Avinash Kulkarni",
  //       duration: "35",
  //       price: "599",
  //     },
  //     {
  //       courseId: "4",
  //       title: "XXI-A PMS Distributor",
  //       author: "Avinash Kulkarni",
  //       duration: "35",
  //       price: "599",
  //     },
  //     {
  //       courseId: "5",
  //       title: "Demo Course 2",
  //       author: "John Doe",
  //       duration: "20",
  //       price: "499",
  //     },
  //   ];

  function getTrainerFullName(trainer) {
if(trainer) {   
    let fullName = trainer?.firstName;
    if (trainer?.middleName) {
      fullName += " " + trainer?.middleName;
    }
    if (trainer?.lastName) {
      fullName += " " + trainer?.lastName;
    }
    return fullName;
  }
  }

  // Filter courses based on search input
  const filteredCourses = coursesData.filter((course) => {
    const searchText = search.toLowerCase();
    const courseName = course.courseName.toLowerCase();
    const author = course.trainer == "null" ? "" : getTrainerFullName(course.trainer )?.toLowerCase();
    const duration = course.minTime.toString().toLowerCase();
    const price = course.minPrice.toString().toLowerCase();

    return (
      courseName.includes(searchText) ||
      author?.includes(searchText) ||
      duration.includes(searchText) ||
      price.includes(searchText)
    );
  });


  return (
    <React.Fragment>
      <div className="course_section_main" id="idOurCoursesMain">
        <div className="course_filter_main">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" id = "course">
              <h3 className="course_sec_title">Our Courses</h3>
            <div className="tabs_main">

              {tabs && tabs.map((category, index) => (
                <button onClick={() => setActiveTab(category.courseCategoryId)} className={`general_tabs ${activeTab == category.courseCategoryId && "active"}`}>
                  {category.courseCategoryName}
                </button>
              ))}
            </div>

            <div className="search_sec_main">
              <div className="serach_inner">
                <div className="" >
                  <input type="search"
                    className="form-control cstm_search"
                    id="idSearch"
                    placeholder="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    autoComplete="off"
                  >
                  </input>
                </div>
                <div className="search_icon">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </div>
              </div>
            </div>
              </div>
            </div>
            
          </div>
        </div>

        <div className="container">
          <h3 className="course_sec_title">{mainSecTitle}</h3>
          {loading ?
            <div className="preloader_course">
              <p className="preloader_text_p">
                Loading
                <span className="loading-dots">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </span>
              </p>
            </div>
            :
            filteredCourses.length > 0 ? (
              <Carousel {...settings} breakPoints={breakPoints}>
                {filteredCourses.map((course, index) => (
                  <CourseItem
                    key={index}
                    title={course.courseName}
                    author={course.trainer == "null" ? "" :  getTrainerFullName(course.trainer)}
                    duration={course.minTime}
                    price={course.minPrice}
                    offerPrice = {course.offerPrice}
                    isActiveOffer = {course.isActiveOffer}
                    courseId={course.id}
                    courseImg={course.coverImage ? course.coverImage : dummyImg}
                    courseData={course}
                    selectedCategory={activeTab}
                    course = {course}
                    courseTypeName= {course.courseTypeName}
                    offerName= {course.offerName}
                    offerEndDate = {course.offerEndDate}
                    launch = {course.launchDate}
                    specialOfferName = {course.specialOfferName}
                    rating = {course.feedbackAvg}
                    feedbackShowInWeb = {course.feedbackShowInWeb}
                  />
                ))}
              </Carousel>
            ) : (
              <div className="no_result_found_main">
                <img src={noResult} className="no_result_img"></img>
                <p className="no_result_text">No result found!</p>
              </div>
            )
          }
        </div>
      </div>
    </React.Fragment>
  );
};

export default Course;
